import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {ListGroup} from 'reactstrap';
import {Manual} from 'manuals/components/Manual';
import CategoryEdit from 'manuals/components/CategoryEdit';

export const scrollToTarget = (target) => {
    target.scrollIntoView({
        behavior: 'smooth', block: 'start'
    })
}

@connect(
    state => ({
        selectedManual: state.manuals.selectedManual,
    })
)
export class ManualContainer extends Component {
    render() {
        const {
            manual,
            index,
            selectedManual,
            setScrollTarget
        } = this.props
        const isManualSelected = selectedManual && manual.id === selectedManual.id
        return <div
            ref={ref => isManualSelected ? setScrollTarget(ref): false}
        >
            <Manual
                index={index + 1}
                template={manual}
            />
        </div>
    }
}

@connect(
    state => ({
        manualList: state.manuals.manualList,
        selectedManual: state.manuals.selectedManual,
        isLoading: state.manuals.isLoading
    })
)
export default class ManualList extends Component {
    render() {
        const {
            manualList,
        } = this.props;

        return (
            <Fragment>
                <CategoryEdit />
                <ListGroup>
                    {
                        manualList.map(
                            (manual, index) =>
                                <ManualContainer
                                    key={`template_${manual.id}`}
                                    manual={manual}
                                    index={index}
                                    setScrollTarget={
                                        (target) => {this.scrollTarget = target}
                                    }
                            />
                        )
                    }
                </ListGroup>
            </Fragment>
        )
    }

    componentDidMount() {
        if(this.scrollTarget) {
            scrollToTarget(this.scrollTarget)
        }
    }
}
